import React from 'react';

import ContentCard from '../../../../../components/ContentCard';
import ContentGroupsList from '../../../../../components/ContentGroupsList';
import { useGetClassesQuery } from '../../../../../services/classes';
import { Class } from '../../../../../services/classes/types';
import { Course } from '../../../../../services/courses/types';
import { Stream } from '../../../../../services/streams/types';

interface ClassesCardProps {
  course?: Course,
  stream?: Stream
}

const ClassesCard = ({ course, stream }: ClassesCardProps) => {
  const { data: classesData, isLoading } = useGetClassesQuery(
    {
      subject: course?.subject,
      course: stream?.course,
      stream: stream?.streamId,
    }, { skip: !course || !stream },
  );

  return (
    <ContentCard variant="outlined" title="Classes">
      <ContentGroupsList
        columns={[
          {
            field: 'name',
            headerName: 'Name',
            renderCell: ({ row }: { row: Class }) => `cl-${row?.subject}-${row?.classId}`,
            width: 240,
          },
          {
            field: 'teacherName',
            headerName: 'Teacher',
            width: 160,
          },
        ]}
        data={classesData?.data || []}
        loading={isLoading}
        getRowHref={(row: Class) => `/admin/class/${course?.subject}/${row?.classId}`}
      />
    </ContentCard>
  );
};

export default ClassesCard;
